import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import { whatsappLink } from "@/config";

// Fixed floating WhatsApp action button with pulse glow.
export const WhatsAppButton = () => {
  return (
    <motion.a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Kontakt via WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-black shadow-[0_0_24px_rgba(37,211,102,0.45)] transition-colors duration-300"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <FaWhatsapp className="relative h-7 w-7" />
    </motion.a>
  );
};

export default WhatsAppButton;
